import { useMemo } from 'react';

import { useSetting } from '@/hooks/useSettings';

import { namedTagDefinitions, parseTagDefinitions, type TagDefinition } from '@repo/shared-types';

/**
 * Tag catalog (colors & types) from the CONTACT_TAG_DEFINITIONS setting.
 * One cached settings read — tag colors resolve client-side, so the contact
 * list carries plain string tags with no extra requests.
 */
export const useTagDefinitions = (): {
  definitions: TagDefinition[];
  byName: Map<string, TagDefinition>;
} => {
  const { data } = useSetting('CONTACT_TAG_DEFINITIONS');
  return useMemo(() => {
    const definitions = namedTagDefinitions(parseTagDefinitions(data?.value));
    return { definitions, byName: new Map(definitions.map((d) => [d.name, d])) };
  }, [data?.value]);
};
